import { apiClient, apiEndpoint } from './api.services';
import { API } from '../constants/api.constants';

export const getSampleRequestsTodoListService = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.TODO_LIST.GET_TODO_LIST}/${data.type}`, {
      params: data,
    });
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const getAllUsers = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.USER_MANAGEMENT.GET_COMPANY_USERS}`, {
      params: data,
    });
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const getTodolistCountService = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.TODO_LIST.GET_TODO_LIST_COUNT}/${data.type}`);
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const exportExcelService = async (data) => {
  try {
    data.timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    return await apiClient.get(`${apiEndpoint}${API.TODO_LIST.TODO_LIST_EXPORT_EXCEL}`, { params: { ...data } });
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const exportToPdfService = async (data) => {
  try {
    data.timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    return await apiClient.get(`${apiEndpoint}${API.TODO_LIST.TODO_LIST_EXPORT_EXCEL}`, { params: { ...data } });
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const getSupplierBrands = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.SUPPLIER.SUPPLIER_BRAND}?supplierId=${data}`);
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const removeSubmitDataFromList = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.TODO_LIST.REMOVE_SUBMIT_TODO_FROM_LIST}`, {
      params: data,
    });
  } catch (error) {
    console.log(error);
    throw error;
  }
};

/**
 * Persists inline Costing TODO edits. Each entry is a whole costing document's changed subtrees,
 * because editing any one combination moves that costing's document-level aggregates.
 * @param {Array<object>} costings the touched costings, already recomputed client-side
 * @returns {Promise<object>} the response envelope carrying per-costing saved/failed outcomes
 */
export const updateCostingTodoService = async (costings) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.TODO_LIST.UPDATE_COSTING_TODO}`, { costings });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

/**
 * Sends inline Costing TODO cell edits for server-side calculation (BM-9220).
 * The body states which cell changed and to what; every figure comes back in the response, so the
 * grid repaints from the server rather than from its own arithmetic.
 * @param {Array<{costingId: string, edits: Array<object>}>} costings the edits, grouped per costing
 * @returns {Promise<object>} the api envelope carrying `saved`, `failed` and `costings`
 */
export const calculateCostingTodoService = async (costings) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.TODO_LIST.CALCULATE_COSTING_TODO}`, { costings });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const addMultiCommentOfCostingService = async (data) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.TODO_LIST.ADD_COMMENT_MULTIPLE_COSTING}`, {
      ...data,
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getCostingStatsService = async (params) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.TODO_LIST.COSTING_STATS}`, {
      params,
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};
